import { Flex } from "@gravity-ui/uikit";
import { useAction, useAtom } from "@reatom/npm-react";
import { useEffect } from "react";
import { getLimitersRequest } from "src/store/fetchers";

import { ProfileCard } from "../../components";
import { LimitCardsList } from "./components";
import styles from "./SubscribeDataWidget.module.scss";

export const SubscribeDataWidget = () => {
  const [limiters] = useAtom(getLimitersRequest.dataAtom);
  const [isLoading] = useAtom(getLimitersRequest.isLoadingAtom);

  const getActiveLimitersAction = useAction(getLimitersRequest);

  useEffect(() => {
    getActiveLimitersAction();
  }, [getActiveLimitersAction]);

  return (
    <ProfileCard title="Активные подписки">
      <Flex gap={4} className={styles.container} direction="column">
        <LimitCardsList limiters={limiters} isLoading={isLoading} />
      </Flex>
    </ProfileCard>
  );
};
